import React from "react";
import CountrySelectionPage from "./pages/CountrySelectionPage/CountrySelectionPage";
import CountryPage from "./pages/CountryPage/CountryPage";
import { Route, Routes } from "react-router-dom";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage/PrivacyPolicyPage";

import {
  germanTranslatedAssets,
  germanTranslations,
} from "./pages/CountryPage/Props/german";

import {
  englishTranslatedAssets,
  englishTranslations,
} from "./pages/CountryPage/Props/english";

import { privacyPolicyDe } from "./pages/PrivacyPolicyPage/props/privacyPolicyDe";
import { privacyPolicyUk } from "./pages/PrivacyPolicyPage/props/privacyPolicyUk";
import { UsercentricsConsentManager } from "./Components/UserCentricsConsentManager/UserCentricsConsentManager";

const App: React.FC = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<CountrySelectionPage />} />
        <Route
          path="/germany"
          element={
            <CountryPage
              translations={germanTranslations}
              assets={germanTranslatedAssets}
            />
          }
        />
        <Route
          path="/uk"
          element={
            <CountryPage
              translations={englishTranslations}
              assets={englishTranslatedAssets}
            />
          }
        />
        <Route
          path="/germany/privacy-policy"
          element={<PrivacyPolicyPage privacyPolicy={privacyPolicyDe} />}
        />
        <Route
          path="/uk/privacy-policy"
          element={<PrivacyPolicyPage privacyPolicy={privacyPolicyUk} />}
        />
      </Routes>
      <UsercentricsConsentManager />
    </>
  );
};

export default App;
